export default "__VITE_PUBLIC_ASSET__8bc26175__"